import React, { useEffect, useRef } from 'react'
import USTemplateDefault from 'src/components/template/us'
import styled from 'styled-components'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'
import FuboFreeTemplate from 'src/components/template/fubofree'
import { useCheckFanduelRSN } from 'src/modules/hooks/useCheckFanduelRSN'
import { fanduelSportsNetworkFAQs } from 'src/constants/faqs'
import { WEB_MARKETING_NBA_COUNTDOWN_TIMER } from 'src/modules/reducers/cohorts/constants'
import { useSelector } from 'react-redux'
import { selectStateForProtobuf } from 'src/modules/reducers'
import { fireUIRenderEvent } from 'src/modules/analytics/v3'
import { useCountdownTest } from 'src/modules/hooks/useCountdownTest'
import { selectAnalyticsReady } from 'src/modules/reducers/analytics'

const BallySportsNBA = (props) => {
  const { showFDPlanCards: isAvailable, rsnData } = useCheckFanduelRSN({ sportType: 'nba' })
  const isEventSent = useRef(false)
  const isEventSentCountdownTimer = useRef(false)
  const stateForProtobuf = useSelector(selectStateForProtobuf)
  const isAnalyticsReady = useSelector(selectAnalyticsReady)

  const { matchCountdownTimer, matchTitle, teamMatches, isCountdownNoSubtitle, isCountdown } =
    useCountdownTest(props.teamId, WEB_MARKETING_NBA_COUNTDOWN_TIMER)

  useEffect(() => {
    if (isAvailable && !isEventSent.current) {
      fireUIRenderEvent(
        {
          type: 'eligible',
          component: 'nba_rsns_is_eligible',
        },
        stateForProtobuf
      )
      isEventSent.current = true
    }
  }, [isAvailable])

  useEffect(() => {
    if (!isEventSentCountdownTimer.current && isAnalyticsReady && teamMatches.length) {
      fireUIRenderEvent(
        {
          component: 'countdown_timer_has_game',
        },
        stateForProtobuf
      )
      isEventSentCountdownTimer.current = true
    }
  }, [isAnalyticsReady, teamMatches.length])

  const commonProps = {
    location: props.location,
    lang: 'en',
    market: 'us',
    video: props.poster ? null : props.video || videos.generic_basketball.videoUrl,
    staticAnnotation: props.staticAnnotation,
    title: matchTitle || props.title,
    subtitle: matchTitle ? (isCountdownNoSubtitle ? null : props.subtitle) : props.subtitle,
    countdownTimer: matchCountdownTimer,
    customNetworks: props.customNetworks || ['fanduelsports'],
    sportId: sportIds.Basketball,
    leagueId: leagueIds.NBA,
    matchtickerSportId: sportIds.Basketball,
    matchtickerLeagueName: 'NBA',
    matchtickerLeagueId: leagueIds.NBA,
  }

  return isAvailable ? (
    <StyledContainer isCountdown={isCountdown}>
      <FuboFreeTemplate
        {...commonProps}
        hasFanduelPlanCards={props.hideFanduelPlanCards ? false : true}
        fanduelRSNData={rsnData}
        additionalFAQs={fanduelSportsNetworkFAQs}
        sportType="nba"
        {...props}
        title={matchTitle || props.title}
        subtitle={matchTitle ? (isCountdownNoSubtitle ? null : props.subtitle) : props.subtitle}
      />
    </StyledContainer>
  ) : (
    <StyledContainer isCountdown={isCountdown}>
      <USTemplateDefault
        {...commonProps}
        {...props}
        networkSet="basketball"
        title={matchTitle || props.title}
        subtitle={matchTitle ? (isCountdownNoSubtitle ? null : props.subtitle) : props.subtitle}
      />
    </StyledContainer>
  )
}
export default BallySportsNBA

const StyledContainer = styled.div`
  ${({ isCountdown }) =>
    isCountdown &&
    `
    .content-container .hero-content {
      max-width: 800px;
    }
    `}
`
